import { RouteConfig } from 'react-router-config'

import AppContainer from '../../client/containers/appContainer'
import FeaturePageContainer from '../../client/containers/featurePageContainer'
import HomePageContainer from '../../client/containers/homePageContainer'
import LandingPageContainer from '../../client/containers/landingPageContainer'
import NotFoundPageContainer from '../../client/containers/notFoundPageContainer'
import SearchPageContainer from '../../client/containers/searchPageContainer'

import searchRoutes from './search.new'

const routeConfig: RouteConfig[] = [
  {
    component: AppContainer,
    path: '/',
    routes: [
      {
        component: HomePageContainer,
        exact: true,
        path: '/'
      },
      {
        component: FeaturePageContainer,
        exact: true,
        path: '/feature'
      },
      {
        component: LandingPageContainer,
        path: '/free/:page'
      },
      ...searchRoutes.map(route => ({
        ...route,
        component: SearchPageContainer
      })),
      {
        component: NotFoundPageContainer,
        path: '/*'
      }
    ]
  }
]

export default routeConfig
